/* eslint-disable jsx-a11y/iframe-has-title */
// import React, { useEffect, useState } from "react";
// import {
//   TextField,
//   Button,
//   Grid,
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   OutlinedInput,
//   Chip,
//   FormHelperText,
//   FormControlLabel, // ✅ add this
//   Checkbox,
// } from "@mui/material";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { API_URL, APP_PREFIX_PATH } from "../config/AppConfig";
// import { useNavigate } from "react-router-dom";

// const Register = () => {
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState([]);

//   const ITEM_HEIGHT = 48;
//   const ITEM_PADDING_TOP = 8;
//   const MenuProps = {
//     PaperProps: {
//       style: {
//         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, // dropdown height control
//         width: 250,
//       },
//     },
//   };

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     businessName: "",
//     address: "",
//     businessLocation: "",
//     businessType: [], // multi-select IDs
//     category: [], // multi-select IDs
//     phoneCode: "+971",
//     phone: "",
//     altPhone: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [mapCenter, setMapCenter] = useState({ lat: 23.2599, lng: 77.4126 }); // default Bhopal

//   // Example business type list
//   const businessTypes = [
//     { id: 1, name: "Importer" },
//     { id: 2, name: "Trader" },
//     { id: 3, name: "Retailer" },
//   ];

//   // Google Maps Autocomplete for Business Location
//   useEffect(() => {
//     if (!window.google) {
//       const script = document.createElement("script");
//       script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDQJC-cQjiKA_M_YCJbbefHMLCzBwzp1zs&libraries=places`;
//       script.async = true;
//       document.body.appendChild(script);

//       script.onload = () => initializeAutocomplete();
//     } else {
//       initializeAutocomplete();
//     }

//     function initializeAutocomplete() {
//       const input = document.getElementById("businessLocation");
//       if (!input) return;

//       const autocomplete = new window.google.maps.places.Autocomplete(input);
//       autocomplete.addListener("place_changed", () => {
//         const place = autocomplete.getPlace();
//         if (place.geometry) {
//           const lat = place.geometry.location.lat();
//           const lng = place.geometry.location.lng();
//           setFormData((prev) => ({
//             ...prev,
//             businessLocation: place.formatted_address,
//           }));
//           setMapCenter({ lat, lng });
//         }
//       });
//     }
//   }, []);

//   // Fetch Categories
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const catRes = await axios.get(`${API_URL}/get_category?user_id=1`);
//         setCategories(
//           catRes.data.categories_arr != "NA" ? catRes.data.categories_arr : []
//         );
//       } catch (err) {
//         console.error("Error fetching categories:", err);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleMultiSelectChange = (name, event) => {
//     const { value } = event.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: typeof value === "string" ? value.split(",") : value,
//     }));
//   };

//   const validate = () => {
//     const tempErrors = {};
//     if (!formData.name) tempErrors.name = "Please enter name";
//     if (!formData.email) tempErrors.email = "Please enter email";
//     else if (!/^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(formData.email))
//       tempErrors.email = "Invalid email format";
//     if (!formData.businessName)
//       tempErrors.businessName = "Please enter business name";
//     if (!formData.phone) tempErrors.phone = "Please enter phone number";
//     if (!formData.password) tempErrors.password = "Please enter password";
//     if (!formData.address) tempErrors.address = "Please enter address";
//     if (!formData.businessLocation)
//       tempErrors.businessLocation = "Please enter business location";
//     if (!formData.businessType.length)
//       tempErrors.businessType = "Please select at least one business type";
//     if (!formData.category.length)
//       tempErrors.category = "Please select at least one category";
//     setErrors(tempErrors);
//     return Object.keys(tempErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       const payload = {
//         owner_name: formData.name,
//         email: formData.email,
//         business_name: formData.businessName,
//         address: formData.address,
//         business_location: formData.businessLocation,
//         business_type: formData.businessType.join(","), // IDs
//         category_ids: formData.category.join(","), // IDs
//         mobile: formData.phone,
//         alternate_mobile: formData.altPhone || "",
//         password: formData.password,
//         device_type: "web",
//         player_id: "web-" + new Date().getTime(),
//         phone_code: formData.phoneCode,
//         latitude: mapCenter.lat.toString(),
//         longitude: mapCenter.lng.toString(),
//       };

//       const res = await axios.post(`${API_URL}/sign_up_website`, payload);

//       if (res.data.success) {
//         Swal.fire({
//           title: "Registered successfully! Please wait for admin approval",
//           icon: "success",
//           confirmButtonText: "OK",
//         }).then(() => {
//           navigate(`/${APP_PREFIX_PATH}/login`);
//         });
//       } else if (res.data.key === "email") {
//         Swal.fire({
//           title: "Email already registered",
//           text: "This email is already registered. Please login or use another email.",
//           icon: "warning",
//           confirmButtonText: "OK",
//         });
//       } else {
//         Swal.fire("Error", res.data.msg || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error", "Something went wrong", "error");
//     }
//   };

//   return (
//     <Box sx={{ display: "flex", justifyContent: "center", mt: 5, mb: 5 }}>
//       <Card sx={{ width: "95%", maxWidth: 1000, p: 3 }}>
//         <CardContent>
//           <Typography variant="h5" mb={3} fontWeight="bold">
//             Create an Account
//           </Typography>

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               {/* Name */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Name"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   error={!!errors.name}
//                   helperText={errors.name}
//                 />
//               </Grid>

//               {/* Email */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   error={!!errors.email}
//                   helperText={errors.email}
//                 />
//               </Grid>

//               {/* Business Name */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Business Name"
//                   name="businessName"
//                   value={formData.businessName}
//                   onChange={handleChange}
//                   error={!!errors.businessName}
//                   helperText={errors.businessName}
//                 />
//               </Grid>

//               {/* Phone Code + Mobile */}
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Phone Code"
//                   name="phoneCode"
//                   value={formData.phoneCode}
//                   onChange={handleChange}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Mobile Number"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   error={!!errors.phone}
//                   helperText={errors.phone}
//                 />
//               </Grid>

//               {/* Alternate Phone */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Alternate Phone"
//                   name="altPhone"
//                   value={formData.altPhone}
//                   onChange={handleChange}
//                 />
//               </Grid>

//               {/* Password */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Password"
//                   name="password"
//                   type="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   error={!!errors.password}
//                   helperText={errors.password}
//                 />
//               </Grid>

//               {/* Address */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Address"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   error={!!errors.address}
//                   helperText={errors.address}
//                 />
//               </Grid>

//               {/* Business Location */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Business Location"
//                   id="businessLocation"
//                   name="businessLocation"
//                   value={formData.businessLocation}
//                   onChange={handleChange}
//                   error={!!errors.businessLocation}
//                   helperText={errors.businessLocation}
//                 />
//               </Grid>

//               {/* Map */}
//               <Grid item xs={12}>
//                 <Box
//                   sx={{
//                     height: 300,
//                     width: "100%",
//                     borderRadius: 2,
//                     overflow: "hidden",
//                   }}
//                 >
//                   <iframe
//                     width="100%"
//                     height="100%"
//                     loading="lazy"
//                     style={{ border: 0 }}
//                     src={`https://www.google.com/maps/embed/v1/view?key=AIzaSyDQJC-cQjiKA_M_YCJbbefHMLCzBwzp1zs&center=${mapCenter.lat},${mapCenter.lng}&zoom=12`}
//                   ></iframe>
//                 </Box>
//               </Grid>

//               {/* Business Type Multi-Select */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth error={!!errors.businessType}>
//                   <InputLabel>Business Type</InputLabel>
//                   <Select
//                     multiple
//                     name="businessType"
//                     value={formData.businessType}
//                     onChange={(e) => handleMultiSelectChange("businessType", e)}
//                     input={<OutlinedInput label="Business Type" />}
//                     renderValue={(selected) => (
//                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                         {selected.map((id) => {
//                           const type = businessTypes.find((b) => b.id === id);
//                           return <Chip key={id} label={type?.name || id} />;
//                         })}
//                       </Box>
//                     )}
//                   >
//                     {businessTypes.map((b) => (
//                       <MenuItem key={b.id} value={b.id}>
//                         {b.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>{errors.businessType}</FormHelperText>
//                 </FormControl>
//               </Grid>

//               {/* ✅ Category Multi-Select Fixed */}
//               {/* <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth error={!!errors.category}>
//                   <InputLabel>Category</InputLabel>
//                   <Select
//                     multiple
//                     name="category"
//                     value={formData.category}
//                     onChange={(e) => handleMultiSelectChange("category", e)}
//                     input={<OutlinedInput label="Category" />}
//                     renderValue={(selected) => (
//                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                         {selected.map((id) => {
//                           const cat = categories.find(
//                             (c) => c.category_id === id
//                           );
//                           return <Chip key={id} label={cat?.category_name || id} />;
//                         })}
//                       </Box>
//                     )}
//                   >
//                     {categories.map((c) => (
//                       <MenuItem key={c.category_id} value={c.category_id}>
//                         {c.category_name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>{errors.category}</FormHelperText>
//                 </FormControl>
//               </Grid> */}
//               {/* Category Checkboxes */}
//               {/* Category Multi-Select with Checkboxes */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth error={!!errors.category}>
//                   <InputLabel>Category</InputLabel>
//                   <Select
//                     multiple
//                     name="category"
//                     value={formData.category}
//                     onChange={(e) => handleMultiSelectChange("category", e)}
//                     input={<OutlinedInput label="Category" />}
//                     renderValue={(selected) =>
//                       selected
//                         .map(
//                           (id) =>
//                             categories.find((c) => c.category_id === id)
//                               ?.category_name
//                         )
//                         .join(", ")
//                     }
//                     MenuProps={MenuProps} // ✅ add this
//                   >
//                     {categories.map((c) => (
//                       <MenuItem key={c.category_id} value={c.category_id}>
//                         <Checkbox
//                           checked={formData.category.includes(c.category_id)}
//                         />
//                         <Typography>{c.category_name}</Typography>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>{errors.category}</FormHelperText>
//                 </FormControl>
//               </Grid>

//               {/* Submit */}
//               <Grid item xs={12}>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   style={{ background: "#f47b1e" }}
//                   fullWidth
//                 >
//                   Register
//                 </Button>
//                 <p className="text-center" style={{ marginTop: "12px" }}>
//                   Already have an account?{" "}
//                   <span
//                     style={{ color: "#007bff", cursor: "pointer" }}
//                     onClick={() => navigate(`/${APP_PREFIX_PATH}/login`)}
//                   >
//                     Login
//                   </span>
//                 </p>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default Register;
// import React, { useEffect, useState } from "react";
// import {
//   TextField,
//   Button,
//   Grid,
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   OutlinedInput,
//   Chip,
//   FormHelperText,
//   Checkbox,
// } from "@mui/material";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { API_URL, APP_PREFIX_PATH } from "../config/AppConfig";
// import { useNavigate } from "react-router-dom";

// const Register = () => {
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState([]);

//   const ITEM_HEIGHT = 48;
//   const ITEM_PADDING_TOP = 8;
//   const MenuProps = {
//     PaperProps: {
//       style: {
//         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//         width: 250,
//       },
//     },
//   };

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     businessName: "",
//     address: "",
//     businessLocation: "",
//     businessType: [],
//     category: [],
//     phoneCode: "+971",
//     phone: "",
//     altPhone: "",
//     password: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [map, setMap] = useState(null);
//   const [marker, setMarker] = useState(null);
//   const [mapCenter, setMapCenter] = useState({ lat: 23.2599, lng: 77.4126 }); // fallback Bhopal

//   const businessTypes = [
//     { id: 1, name: "Importer" },
//     { id: 2, name: "Trader" },
//     { id: 3, name: "Retailer" },
//   ];

//   // Initialize map & autocomplete
//   useEffect(() => {
//     const loadGoogleMaps = () => {
//       if (!window.google) {
//         const script = document.createElement("script");
//         script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDQJC-cQjiKA_M_YCJbbefHMLCzBwzp1zs&libraries=places`;
//         script.async = true;
//         document.body.appendChild(script);
//         script.onload = () => initMapAndAutocomplete();
//       } else {
//         initMapAndAutocomplete();
//       }
//     };

//     const initMapAndAutocomplete = () => {
//       // Initialize map at default/fallback center first
//       const initialMap = new window.google.maps.Map(document.getElementById("map"), {
//         center: mapCenter,
//         zoom: 12,
//       });
//       setMap(initialMap);

//       // Try getting user location
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             const userLat = position.coords.latitude;
//             const userLng = position.coords.longitude;
//             initialMap.setCenter({ lat: userLat, lng: userLng });

//             const userMarker = new window.google.maps.Marker({
//               position: { lat: userLat, lng: userLng },
//               map: initialMap,
//               title: "You are here!",
//             });
//             setMarker(userMarker);
//           },
//           (error) => console.warn("Location denied, using default Bhopal", error)
//         );
//       }

//       // Autocomplete
//       const input = document.getElementById("businessLocation");
//       if (!input) return;

//       const autocomplete = new window.google.maps.places.Autocomplete(input);
//       autocomplete.addListener("place_changed", () => {
//         const place = autocomplete.getPlace();
//         if (place.geometry) {
//           const lat = place.geometry.location.lat();
//           const lng = place.geometry.location.lng();
//           setFormData((prev) => ({
//             ...prev,
//             businessLocation: place.formatted_address,
//           }));

//           initialMap.setCenter({ lat, lng });
//           initialMap.setZoom(12);

//           // Move or create marker
//           if (marker) {
//             marker.setPosition({ lat, lng });
//             marker.setTitle(place.formatted_address);
//           } else {
//             const newMarker = new window.google.maps.Marker({
//               position: { lat, lng },
//               map: initialMap,
//               title: place.formatted_address,
//             });
//             setMarker(newMarker);
//           }
//         }
//       });
//     };

//     loadGoogleMaps();
//   }, [marker]);

//   // Fetch Categories
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const catRes = await axios.get(`${API_URL}/get_category?user_id=1`);
//         setCategories(
//           catRes.data.categories_arr !== "NA" ? catRes.data.categories_arr : []
//         );
//       } catch (err) {
//         console.error("Error fetching categories:", err);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleMultiSelectChange = (name, event) => {
//     const { value } = event.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: typeof value === "string" ? value.split(",") : value,
//     }));
//   };

//   const validate = () => {
//     const tempErrors = {};
//     if (!formData.name) tempErrors.name = "Please enter name";
//     if (!formData.email) tempErrors.email = "Please enter email";
//     else if (!/^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(formData.email))
//       tempErrors.email = "Invalid email format";
//     if (!formData.businessName) tempErrors.businessName = "Please enter business name";
//     if (!formData.phone) tempErrors.phone = "Please enter phone number";
//     if (!formData.password) tempErrors.password = "Please enter password";
//     if (!formData.address) tempErrors.address = "Please enter address";
//     if (!formData.businessLocation) tempErrors.businessLocation = "Please enter business location";
//     if (!formData.businessType.length) tempErrors.businessType = "Please select at least one business type";
//     if (!formData.category.length) tempErrors.category = "Please select at least one category";
//     setErrors(tempErrors);
//     return Object.keys(tempErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       const payload = {
//         owner_name: formData.name,
//         email: formData.email,
//         business_name: formData.businessName,
//         address: formData.address,
//         business_location: formData.businessLocation,
//         business_type: formData.businessType.join(","),
//         category_ids: formData.category.join(","),
//         mobile: formData.phone,
//         alternate_mobile: formData.altPhone || "",
//         password: formData.password,
//         device_type: "web",
//         player_id: "web-" + new Date().getTime(),
//         phone_code: formData.phoneCode,
//         latitude: marker?.getPosition()?.lat().toString() || mapCenter.lat.toString(),
//         longitude: marker?.getPosition()?.lng().toString() || mapCenter.lng.toString(),
//       };

//       const res = await axios.post(`${API_URL}/sign_up_website`, payload);

//       if (res.data.success) {
//         Swal.fire({
//           title: "Registered successfully! Please wait for admin approval",
//           icon: "success",
//           confirmButtonText: "OK",
//         }).then(() => navigate(`/${APP_PREFIX_PATH}/login`));
//       } else if (res.data.key === "email") {
//         Swal.fire({
//           title: "Email already registered",
//           text: "This email is already registered. Please login or use another email.",
//           icon: "warning",
//           confirmButtonText: "OK",
//         });
//       } else {
//         Swal.fire("Error", res.data.msg || "Something went wrong", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error", "Something went wrong", "error");
//     }
//   };

//   return (
//     <Box sx={{ display: "flex", justifyContent: "center", mt: 5, mb: 5 }}>
//       <Card sx={{ width: "95%", maxWidth: 1000, p: 3 }}>
//         <CardContent>
//           <Typography variant="h5" mb={3} fontWeight="bold">
//             Create an Account
//           </Typography>

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               {/* Name */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Name"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   error={!!errors.name}
//                   helperText={errors.name}
//                 />
//               </Grid>

//               {/* Email */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   error={!!errors.email}
//                   helperText={errors.email}
//                 />
//               </Grid>

//               {/* Business Name */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Business Name"
//                   name="businessName"
//                   value={formData.businessName}
//                   onChange={handleChange}
//                   error={!!errors.businessName}
//                   helperText={errors.businessName}
//                 />
//               </Grid>

//               {/* Phone Code + Mobile */}
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Phone Code"
//                   name="phoneCode"
//                   value={formData.phoneCode}
//                   onChange={handleChange}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Mobile Number"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   error={!!errors.phone}
//                   helperText={errors.phone}
//                 />
//               </Grid>

//               {/* Alternate Phone */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Alternate Phone"
//                   name="altPhone"
//                   value={formData.altPhone}
//                   onChange={handleChange}
//                 />
//               </Grid>

//               {/* Password */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Password"
//                   name="password"
//                   type="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   error={!!errors.password}
//                   helperText={errors.password}
//                 />
//               </Grid>

//               {/* Address */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Address"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   error={!!errors.address}
//                   helperText={errors.address}
//                 />
//               </Grid>

//               {/* Business Location */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Business Location"
//                   id="businessLocation"
//                   name="businessLocation"
//                   value={formData.businessLocation}
//                   onChange={handleChange}
//                   error={!!errors.businessLocation}
//                   helperText={errors.businessLocation}
//                 />
//               </Grid>

//               {/* Map */}
//               <Grid item xs={12}>
//                 <Box
//                   id="map"
//                   sx={{ height: 300, width: "100%", borderRadius: 2, overflow: "hidden" }}
//                 />
//               </Grid>

//               {/* Business Type Multi-Select */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth error={!!errors.businessType}>
//                   <InputLabel>Business Type</InputLabel>
//                   <Select
//                     multiple
//                     name="businessType"
//                     value={formData.businessType}
//                     onChange={(e) =>
//                       handleMultiSelectChange("businessType", e)
//                     }
//                     input={<OutlinedInput label="Business Type" />}
//                     renderValue={(selected) => (
//                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                         {selected.map((id) => {
//                           const type = businessTypes.find((b) => b.id === id);
//                           return <Chip key={id} label={type?.name || id} />;
//                         })}
//                       </Box>
//                     )}
//                   >
//                     {businessTypes.map((b) => (
//                       <MenuItem key={b.id} value={b.id}>
//                         {b.name}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>{errors.businessType}</FormHelperText>
//                 </FormControl>
//               </Grid>

//               {/* Category Multi-Select with Checkboxes */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth error={!!errors.category}>
//                   <InputLabel>Category</InputLabel>
//                   <Select
//                     multiple
//                     name="category"
//                     value={formData.category}
//                     onChange={(e) => handleMultiSelectChange("category", e)}
//                     input={<OutlinedInput label="Category" />}
//                     renderValue={(selected) =>
//                       selected
//                         .map(
//                           (id) =>
//                             categories.find((c) => c.category_id === id)
//                               ?.category_name
//                         )
//                         .join(", ")
//                     }
//                     MenuProps={MenuProps}
//                   >
//                     {categories.map((c) => (
//                       <MenuItem key={c.category_id} value={c.category_id}>
//                         <Checkbox
//                           checked={formData.category.includes(c.category_id)}
//                         />
//                         <Typography>{c.category_name}</Typography>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>{errors.category}</FormHelperText>
//                 </FormControl>
//               </Grid>

//               {/* Submit */}
//               <Grid item xs={12}>
//                 <Button
//                   type="submit"
//                   variant="contained"
//                   style={{ background: "#f47b1e" }}
//                   fullWidth
//                 >
//                   Register
//                 </Button>
//                 <p className="text-center" style={{ marginTop: "12px" }}>
//                   Already have an account?{" "}
//                   <span
//                     style={{ color: "#007bff", cursor: "pointer" }}
//                     onClick={() => navigate(`/${APP_PREFIX_PATH}/login`)}
//                   >
//                     Login
//                   </span>
//                 </p>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default Register;

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  OutlinedInput,
  Chip,
  FormHelperText,
  Checkbox,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL, APP_PREFIX_PATH } from "../config/AppConfig";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 25.2048493, lng: 55.2707828 }); // Dubai default

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    businessName: "",
    address: "",
    businessLocation: "",
    businessType: [],
    category: [],
    phoneCode: "+971",
    phone: "",
    altPhone: "",
    password: "",
    latitude: "", // added
    longitude: "", // added
  });

  console.log("formData : ",formData);
  

  const [errors, setErrors] = useState({});

  const businessTypes = [
    { id: 1, name: "Importer" },
    { id: 2, name: "Trader" },
    { id: 3, name: "Retailer" },
  ];

  // Load Google Maps and Autocomplete
  useEffect(() => {
    const loadGoogleMaps = () => {
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDQJC-cQjiKA_M_YCJbbefHMLCzBwzp1zs&libraries=places`;
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => initMapAndAutocomplete();
      } else {
        initMapAndAutocomplete();
      }
    };

    const initMapAndAutocomplete = () => {
      // Initialize map
      const initialMap = new window.google.maps.Map(
        document.getElementById("map"),
        {
          center: mapCenter,
          zoom: 12,
        }
      );
      setMap(initialMap);

      // Try to get user geolocation
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            initialMap.setCenter({ lat: userLat, lng: userLng });
            setMapCenter({ lat: userLat, lng: userLng });
          },
          () => {
            console.warn("Geolocation denied, using default Dubai");
          }
        );
      }

      // Add marker
      const initialMarker = new window.google.maps.Marker({
        position: mapCenter,
        map: initialMap,
        title: "Selected Location",
      });
      setMarker(initialMarker);

      // Autocomplete
      const input = document.getElementById("businessLocation");
      if (!input) return;

      const autocomplete = new window.google.maps.places.Autocomplete(input);
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.geometry) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          setFormData((prev) => ({
            ...prev,
            businessLocation: place.formatted_address,
            latitude: lat.toString(),
            longitude: lng.toString(),
          }));

          initialMap.setCenter({ lat, lng });
          initialMap.setZoom(12);

          // Move marker
          if (initialMarker) {
            initialMarker.setPosition({ lat, lng });
            initialMarker.setTitle(place.formatted_address);
          }
        }
      });
    };

    loadGoogleMaps();
  }, []);

  // Fetch Categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API_URL}/get_category?user_id=1`);
        setCategories(
          res.data.categories_arr !== "NA" ? res.data.categories_arr : []
        );
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (name, event) => {
    const { value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const validate = () => {
    const tempErrors = {};
    if (!formData.name) tempErrors.name = "Please enter name";
    if (!formData.email) tempErrors.email = "Please enter email";
    else if (!/^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(formData.email))
      tempErrors.email = "Invalid email format";
    if (!formData.businessName)
      tempErrors.businessName = "Please enter business name";
    if (!formData.phone) tempErrors.phone = "Please enter phone number";
    if (!formData.password) tempErrors.password = "Please enter password";
    if (!formData.address) tempErrors.address = "Please enter address";
    if (!formData.businessLocation)
      tempErrors.businessLocation = "Please enter business location";
    if (!formData.businessType.length)
      tempErrors.businessType = "Please select at least one business type";
    if (!formData.category.length)
      tempErrors.category = "Please select at least one category";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const payload = {
        owner_name: formData.name,
        email: formData.email,
        business_name: formData.businessName,
        address: formData.address,
        business_location: formData.businessLocation,
        business_type: formData.businessType.join(","),
        category_ids: formData.category.join(","),
        mobile: formData.phone,
        alternate_mobile: formData.altPhone || "",
        password: formData.password,
        device_type: "web",
        player_id: "web-" + new Date().getTime(),
        phone_code: formData.phoneCode,
        latitude: formData.latitude || mapCenter.lat.toString(),
        longitude: formData.longitude || mapCenter.lng.toString(),
      };

      const res = await axios.post(`${API_URL}/sign_up_website`, payload);

      if (res.data.success) {
        Swal.fire({
          title: "Registered successfully! Please wait for admin approval",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => navigate(`/${APP_PREFIX_PATH}/login`));
      } else if (res.data.key === "email") {
        Swal.fire({
          title: "Email already registered",
          text: "This email is already registered. Please login or use another email.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire("Error", res.data.msg || "Something went wrong", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5, mb: 5 }}>
      <Card sx={{ width: "95%", maxWidth: 1000, p: 3 }}>
        <CardContent>
          <Typography variant="h5" mb={3} fontWeight="bold">
            Create an Account
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </Grid>

              {/* Email */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </Grid>

              {/* Business Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Business Name"
                  name="businessName"
                  value={formData.businessName}
                  onChange={handleChange}
                  error={!!errors.businessName}
                  helperText={errors.businessName}
                />
              </Grid>

              {/* Phone */}
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Phone Code"
                  name="phoneCode"
                  value={formData.phoneCode}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Mobile Number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                />
              </Grid>

              {/* Alternate Phone */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Alternate Phone"
                  name="altPhone"
                  value={formData.altPhone}
                  onChange={handleChange}
                />
              </Grid>

              {/* Password */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  error={!!errors.password}
                  helperText={errors.password}
                />
              </Grid>

              {/* Address */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  error={!!errors.address}
                  helperText={errors.address}
                />
              </Grid>

              {/* Business Location */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Business Location"
                  id="businessLocation"
                  name="businessLocation"
                  value={formData.businessLocation}
                  onChange={handleChange}
                  error={!!errors.businessLocation}
                  helperText={errors.businessLocation}
                />
              </Grid>

              {/* Map */}
              <Grid item xs={12}>
                <Box
                  id="map"
                  sx={{ height: 300, width: "100%", borderRadius: 2 }}
                />
              </Grid>

              {/* Business Type */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth error={!!errors.businessType}>
                  <InputLabel>Business Type</InputLabel>
                  <Select
                    multiple
                    name="businessType"
                    value={formData.businessType}
                    onChange={(e) =>
                      handleMultiSelectChange("businessType", e)
                    }
                    input={<OutlinedInput label="Business Type" />}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((id) => {
                          const type = businessTypes.find((b) => b.id === id);
                          return <Chip key={id} label={type?.name || id} />;
                        })}
                      </Box>
                    )}
                  >
                    {businessTypes.map((b) => (
                      <MenuItem key={b.id} value={b.id}>
                        {b.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.businessType}</FormHelperText>
                </FormControl>
              </Grid>

              {/* Category */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth error={!!errors.category}>
                  <InputLabel>Category</InputLabel>
                  <Select
                    multiple
                    name="category"
                    value={formData.category}
                    onChange={(e) => handleMultiSelectChange("category", e)}
                    input={<OutlinedInput label="Category" />}
                    renderValue={(selected) =>
                      selected
                        .map(
                          (id) =>
                            categories.find((c) => c.category_id === id)
                              ?.category_name
                        )
                        .join(", ")
                    }
                    MenuProps={MenuProps}
                  >
                    {categories.map((c) => (
                      <MenuItem key={c.category_id} value={c.category_id}>
                        <Checkbox
                          checked={formData.category.includes(c.category_id)}
                        />
                        <Typography>{c.category_name}</Typography>
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.category}</FormHelperText>
                </FormControl>
              </Grid>

              {/* Submit */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  style={{ background: "#f47b1e" }}
                  fullWidth
                >
                  Register
                </Button>
                <p className="text-center" style={{ marginTop: "12px" }}>
                  Already have an account?{" "}
                  <span
                    style={{ color: "#007bff", cursor: "pointer" }}
                    onClick={() => navigate(`/${APP_PREFIX_PATH}/login`)}
                  >
                    Login
                  </span>
                </p>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Register;
